import React from "react";
import Bpo from "../../pages/timeline/Bpo.jsx";
import Autonomo from "../../pages/timeline/Autonomo.jsx";
import Mei from "../../pages/timeline/Mei.jsx";
import Migracao from "../../pages/timeline/Migracao.jsx";
import TimelineMigracao from "../../pages/timeline/TimelineMigracao.jsx";
const prefix = process.env.REACT_APP_PREFIX;

const timelineRoutes = [
  {
    path: `${prefix}/timeline/Bpo/`,
    component: <Bpo />,
    title: "Processos BPO",
  },
  {
    path: `${prefix}/timeline/EmpresasAutonomo/`,
    component: <Autonomo />,
    title: "Processos autônomos",
  },
  {
    path: `${prefix}/timeline/EmpresasMEI/`,
    component: <Mei />,
    title: "Processos MEI",
  },
  {
    path: `${prefix}/timeline/EmpresasMigracao/`,
    component: <Migracao />,
    title: "Processos de Migração",
  },
  {
    path: `${prefix}/timeline/TimelineMigracao/index/:uid`,
    component: <TimelineMigracao />,
    title: "Processos de Migração",
  },
  {
    path: `${prefix}/timeline/TimelineMigracao/`,
    component: <TimelineMigracao />,
    title: "Processos de Migração",
  },
];

export default timelineRoutes;
